import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons/index';
import { renderDateWithTimeZone } from '../../../../helpers/timezones';
import { timeFormatShort, defaultTimeZone } from '../../../../constants/date';
import { appPath } from '../../../../constants';
import styled from 'styled-components'

const StyledOrientation = styled.div`
  cursor: pointer;
`

export default class OrientationItem extends Component {
  static propTypes = {
    orientation: PropTypes.shape({
      id: PropTypes.number,
      location: PropTypes.object,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
      seats: PropTypes.number,
      seats_remaining: PropTypes.number,
      users: PropTypes.array,
      selecting: PropTypes.bool,
      updateOrientation: PropTypes.func
    })
  };

  render () {
    const { orientation, selecting, updateOrientation } = this.props;
    const { id, location: { name, address, city, state, zip, time_zone_id }, start_date, end_date, seats, seats_remaining } = orientation;
    const timeShift = start_date ? renderDateWithTimeZone(start_date, timeFormatShort, time_zone_id || defaultTimeZone, end_date) : '';

    const content = (
      <Fragment>
        <p className='name no-wrap orientation-name'>{ name }</p>
        <p>{ address }, { city }, { state }, { zip }</p>
        <p>{ timeShift }</p>
        <p>
          <span className='mr-2 muted'><FontAwesomeIcon icon={faUser} /></span>
          {seats - seats_remaining} / {seats}
        </p>
      </Fragment>
    )

    return (
      selecting
        ? <StyledOrientation className='dashboard-item-wrapper orientation-info' onClick={() => updateOrientation(orientation.id)}>{content}</StyledOrientation>
        : <Link
            className='dashboard-item-wrapper orientation-info'
            to={`/${appPath}/orientations/${id}`}
          >
            {content}
          </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/orientations/OrientationsList/OrientationItem.js